import { render, staticRenderFns } from "./Posta.vue?vue&type=template&id=bb35dfa6&"
import script from "./Posta.vue?vue&type=script&lang=js&"
export * from "./Posta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports